import { maskedLabel } from "../Utils/StringUtils";

export const REPORTS = [
  {
    value: "Summary",
    label: "Summary",
  },
  {
    value: "GeneralJournal",
    label: "General Journal",
  },
  {
    value: "BalanceSheet",
    label: "Balance Sheet",
  },
  {
    value: "TrialBalance",
    label: "Trial Balance",
  },
  {
    value: "IncomeStatement",
    label: "Income Statement",
  },
  {
    value: "CapitalStatement",
    label: "Capital Statement",
  },
  {
    value: "CashFlow",
    label: "Cash Flow",
  },
];

export const EXPORTS = [
  {
    value: "pdf",
    label: "PDF",
  },
  {
    value: "xlsx",
    label: "XLSX",
  },
];

export const INCOME_CATEGORIES = [
  "INCOME",
  "COST_OF_GOODS_SOLD",
  "GROSS_PROFIT",
  "EXPENSE",
  "OPERATING_PROFIT",
  "OTHER_INCOME",
  "OTHER_EXPENSE",
  "NET_PROFIT",
];

export const ACCOUNT_CATEGORY = {
  ACCOUNTS_RECEIVABLE: "Accounts Receivable",
  OTHER_CURRENT_ASSETS: "Other Current Assets",
  CASH_AND_BANK: "Cash & Bank",
  INVENTORY: "Inventory",
  FIXED_ASSETS: "Fixed Assets",
  OTHER_ASSETS: "Other Assets",
  DEPRECIATION_AND_AMORTIZATION: "Depreciation & Amortization",
  ACCOUNTS_PAYABLE: "Accounts Payable",
  OTHER_CURRENT_LIABILITIES: "Other Current Liabilities",
  LONG_TERM_OBLIGATION: "Long-term Obligation",
  CAPITAL: "Equity",
  INCOME: "Revenue",
  OTHER_INCOME: "Other Revenue",
  COST_OF_GOODS_SOLD: "Cost of Goods Sold",
  EXPENSE: "Expenses",
  OTHER_EXPENSE: "Other Expenses",
  GROSS_PROFIT: "Gross Profit",
  OPERATING_PROFIT: "Operating Profit",
  NET_PROFIT: "Net Profit",
};

export const CASHFLOW_ACCOUNT_CATEGORY = {
  INCOME: "Revenue from Customers",
  INCOME_RECEIVABLE: "Revenue Receivable",
  ACCOUNTS_RECEIVABLE: "Change in Accounts Receivable",
  CASH_AND_BANK: "Cash & Bank",
  INVENTORY: "Change in Inventory",
  OTHER_CURRENT_ASSETS: "Other Current Assets",
  COST_OF_GOODS_SOLD: "Payment to Suppliers",
  ACCOUNTS_PAYABLE: "Change in Accounts Payable",
  EXPENSE_PAYABLE: "Expense Payable",
  OTHER_CURRENT_LIABILITIES: "Other Short-term Liabilities",
  OTHER_INCOME: "Other Revenues",
  EXPENSE: "Operating Expenses",
  OTHER_EXPENSE: "Other Expenses",
  FIXED_ASSETS: "Acquisition/Sale of Assets",
  OTHER_ASSETS: "Other Investment Activities",
  LONG_TERM_OBLIGATION: "Payment/Receipt of Loans",
  CAPITAL: "Equity/Capital",
  DEPRECIATION_AND_AMORTIZATION: "Depreciation & Amortization",
  OTHER: "Other Operating Activities",
};

// Report labels: raw API enums (e.g. DEPRECIATION_AND_AMORTIZATION) must never
// reach the screen. Lookups fall back to a humanized form of the enum, so an
// unmapped category still reads as regular text instead of the enum itself.
const categoryLabel = (labels) => (category) => maskedLabel(labels, category);

export const accountCategoryLabel = categoryLabel(ACCOUNT_CATEGORY);
export const cashFlowAccountCategoryLabel = categoryLabel(
  CASHFLOW_ACCOUNT_CATEGORY
);

// Where the report picker on the old /accounting page goes. The old report
// pages were retired for these; their own URLs redirect here as well.
export const reportRoutes = {
  GeneralJournal: "/v2/accounting/reports/general-journal",
  TrialBalance: "/v2/accounting/reports/trial-balance",
  IncomeStatement: "/v2/accounting/reports/income-statement",
  CapitalStatement: "/v2/accounting/reports/capital-statement",
  CashFlow: "/v2/accounting/reports/cash-flow",
  BalanceSheet: "/v2/accounting/reports/balance-sheet",
  Summary: "/v2/accounting/reports/summary",
};

export const REPORT_OPTIONS = [
  {
    id: "accounting-summary",
    name: "reports.summaries.name",
    description: "reports.summaries.description",
  },
  {
    id: "general-journal",
    name: "reports.generalJournals.name",
    description: "reports.generalJournals.description",
  },
  {
    id: "balance-sheet",
    name: "reports.balanceSheets.name",
    description: "reports.balanceSheets.description",
  },
  {
    id: "trial-balance",
    name: "reports.trialBalances.name",
    description: "reports.trialBalances.description",
  },
  {
    id: "income-statement",
    name: "reports.incomeStatements.name",
    description: "reports.incomeStatements.description",
  },
  {
    id: "capital-statement",
    name: "reports.capitalStatements.name",
    description: "reports.capitalStatements.description",
  },
  {
    id: "cash-flow",
    name: "reports.cashFlow.name",
    description: "reports.cashFlow.description",
  },
];

// Receivable and payable reports. Kept apart from REPORT_OPTIONS, which the
// embedded report list also renders. The partner ledger needs a contact, so
// its card has no quick download.
export const PARTNER_REPORT_OPTIONS = [
  {
    id: "aging",
    name: "reports.aging.name",
    description: "reports.aging.description",
  },
  {
    id: "partner-ledger",
    name: "reports.partnerLedger.name",
    description: "reports.partnerLedger.description",
    download: false,
  },
];
